import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import useArtifact from 'hooks/useArtifacts';
import Typography from 'components/Atoms/Typography';
import Loader from 'components/Loader';
import ArtifectFolderDetail from 'components/HypertestJobDetail/Artifact/ArtifectFolderDetail';

import './style.css';

const queryString = require('query-string');

let callMade = false;
function Artifacts() {
  const { jobId = '' } = useParams();

  const {
    artefactName = '',
    taskID = '',
    filter = '',
    view = '',
  } = queryString.parse(window.location.search);

  const {
    promoBannerHeight,
    currentArtefact,
    artefactContentStructure,
    fetchArtifactsForPage,
    openArtifactInSamePage,
  } = useArtifact({ jobId, artefactName, taskID, filter, view });

  const data = artefactContentStructure?.data?.data;

  function hasMultipleFiles(params) {
    let hasMultiple = false;
    let fileUrl = '';
    if (!params) {
      return [false, ''];
    }
    if (params.type === 'folder') {
      if (Array.isArray(params.files)) {
        if (params.files.length === 1) {
          [hasMultiple, fileUrl] = hasMultipleFiles(params.files[0]);
        } else {
          hasMultiple = true;
        }
      } else {
        const keys = Object.keys(params.files || {});
        if (keys && keys.length === 1) {
          const info = params.files[keys[0]];
          [hasMultiple, fileUrl] = hasMultipleFiles(info);
        } else {
          hasMultiple = false;
        }
      }
    } else {
      if (params.type === 'file' && params.download_link) {
        hasMultiple = false;
        fileUrl = params.download_link;
      } else if (params.files.length > 1) {
        hasMultiple = true;
      }
    }

    return [hasMultiple, fileUrl];
  }

  const [hasManyFiles, downloadLink] = hasMultipleFiles(data);

  useEffect(() => {
    fetchArtifactsForPage();

    // Update styles
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    //  eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (artefactContentStructure.loading) {
    return (
      <div className="artifacts">
        <Loader isSuspenseLoader={true} />
      </div>
    );
  }

  if (!hasManyFiles && downloadLink) {
    !callMade && openArtifactInSamePage(downloadLink, window);
    callMade = true;
    return (
      <div className="artifacts">
        <Loader isSuspenseLoader={true} />
      </div>
    );
  }

  return (
    <div className="artifacts">
      <div
        className={`ltw-inline-block artifact-wrapper ltw-h-screen ltw-w-full ltw-p-10 ${
          promoBannerHeight > 0 ? 'modalSidebarBannerPadding' : ''
        } ltw-mb-8 ltw-overflow-hidden ltw-text-left ltw-align-middle ltw-transition-all ltw-transform ltw-bg-white`}
      >
        <div className="ltw-flex ltw-justify-between">
          <Typography
            variant="h2"
            fontSize="ltw-font-16"
            lineHeight="ltw-leading-19"
          >
            Artifacts
          </Typography>
        </div>

        {currentArtefact && (
          <ArtifectFolderDetail
            currentArtefact={currentArtefact}
            artefactContentStructure={artefactContentStructure}
          />
        )}
      </div>
    </div>
  );
}

export default Artifacts;
